import React from "react";
import { Button } from "semantic-ui-react";
import Calibration1_PSM5 from "./Calibration1_PSM5";
import Calibration2_PSM5 from "./Calibration2_PSM5";
import Calibration3_PSM5 from "./Calibration3_PSM5";
import NonLinear_PSM5 from "./NonLinear_PSM5";

import Calibration4_PSM5 from "./Calibration4_PSM5";
import Calibration5_PSM5 from "./Calibration5_PSM5";

const CalibrationIO_PSM5 = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <Calibration1_PSM5 />;
      case "2":
        return <Calibration2_PSM5 />;
      case "3":
        return <Calibration3_PSM5 />;
      //  case '4':
      //     return <Calibration4_PSM5/>;
      // case '7':
      //     return <NonLinear_PSM5/>;
      default:
        return <Calibration1_PSM5 />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="Analog IO Calibration Page1"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="Analog IO Calibration Page2"
        />
        <Button
          size="medium"
          id="3"
          active={toggleButton === "3"}
          onClick={handleClick}
          content="Analog IO Calibration Page3"
        />
        {/*<Button*/}
        {/*    size='medium'*/}
        {/*    id='4'*/}
        {/*    active={toggleButton==='4'}*/}
        {/*    onClick={handleClick}*/}
        {/*    content='Analog IO Calibration Page4'*/}
        {/*/>*/}
        {/*<Button*/}
        {/*    size='medium'*/}
        {/*    id='7'*/}
        {/*    active={toggleButton==='7'}*/}
        {/*    onClick={handleClick}*/}
        {/*    content='Non Linear Calibration'*/}
        {/*/>*/}
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default CalibrationIO_PSM5;
